import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { TimeStamp } from "../../Atoms/TimeStamp";
import { array, object, string } from "prop-types";
import { CollectionOnlyLayout } from "../CollectonOnlyLayout";
import useSimilarSections from "../../../../hook/useSimilarSections";
import ImageType3 from "../../../../components/molecules/image-type-3";
import ImageType4 from "../../../../components/molecules/image-type-4";
//import { SectionName } from "../../../../components/molecules/section-name";
import { collectionToStories, Link, ResponsiveImage } from "@quintype/components";
import BigSectionHeroImage from "../../../../components/story-templates/big-section-hero-image";
import "./one-big-three-small-section-layout.m.css";

function OneBigThreeSmallSectionLayoutBase({ collection, childCollections, oneCollectionData, currentPath, behindPaywall, contentType, ageRestriction }) {
  const [collectionName, setCollectionName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [isSort, setIsSort] = useState(false);
  const [activeTab, setActiveTab] = useState("jaksot");
  const [selectedButton, setSelectedButton] = useState(0);
  const [similarSections, setSimilarSections] = useState([]);
  const stateConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const [storiesFromSectionSlug, setStoriesFromSectionSlug] = useState([]);
  const bgColor =
    get(collection, ["associated-metadata", "Type bgColors for entire layout from (black, peach, yellow, violet)"]) ||
    "black";
  const showHideSamanlaisiaOhjelmia = collection.testFreeTextAttribute && collection.testFreeTextAttribute;
  const getSelectedCollection = childCollections.find((col) => col.name === collectionName) || collection;
  const storiesFromCollection = !childCollections
    ? collectionToStories(collection)
    : collectionToStories(getSelectedCollection);
  if (storiesFromCollection.length < 1) {
    return <h2 styleName="no-contents">{`Please provide contents for "${collection.name}"`} </h2>;
  }
  const latestEpisode = isSort
    ? storiesFromCollection[storiesFromCollection.length - 1] || {}
    : storiesFromCollection[0] || {};
  /** we are extracting the first ever created story, not the latest story so that
   * even if latest stories change the first ever created will hold the related images always
   */

  let firstStory, restOftheStories;
  if (storiesFromCollection.length === 1) {
    firstStory = storiesFromCollection[0]; // Extract the single object as firstStory
    restOftheStories = storiesFromCollection; // No remaining objects
  } else if (storiesFromCollection.length > 1) {
    firstStory = storiesFromCollection[storiesFromCollection.length - 1]; // Get the last object
    restOftheStories = storiesFromCollection.filter((exceptFirstStory) => exceptFirstStory !== latestEpisode); // Get all except the last object
  } else {
    // Handle empty array case
    firstStory = null; // Or any default value you'd like
    restOftheStories = [];
  }
  const storyFromSectionSlugOrder =
    storiesFromSectionSlug && isSort
      ? storiesFromSectionSlug.sort((a, b) => a["published-at"] - b["published-at"])
      : storiesFromSectionSlug.sort((a, b) => b["published-at"] - a["published-at"]);
  const handleSort = () => setIsSort(!isSort);
  // Flatten sections from all items
  const storieKlipit =
    storiesFromCollection &&
    storiesFromCollection.filter((story) =>
      story.sections.some((section) => section.name.split("/")[0].trim() === "Klipit")
    );
  const relatedSections = storiesFromCollection
    .flatMap((sectionItem) => sectionItem.sections)
    .filter((secObj) => secObj.name.split("/")[0].trim() !== "Klipit")
    .map((secObj) => ({
      secName: secObj.name,
      slug: secObj.slug,
      completeUrl: secObj["section-url"],
      secObject: secObj,
    }));
  const oldestToNewest = collection.datas.collection?.metadata["listing-order"]?.[0]?.name;
  //reverse series / kausi
  const uniqueRelatedSections =
    oldestToNewest && oldestToNewest === "Vanhin ensin"
      ? relatedSections
          .reverse()
          .filter(
            (item, index, self) => index === self.findIndex((otherItem) => otherItem.completeUrl === item.completeUrl)
          )
      : relatedSections.filter(
          (item, index, self) => index === self.findIndex((otherItem) => otherItem.completeUrl === item.completeUrl)
        );

  const defaultSectionNameFirstIndex = uniqueRelatedSections.length >= 2 ? uniqueRelatedSections[0].secName : "";

  useEffect(() => {
    let sectionName = defaultSectionNameFirstIndex;
    if (
      currentPath.startsWith("/uusimmat") ||
      currentPath.startsWith("/lammas/uusimmat") ||
      currentPath.startsWith("/suosittua-nyt") ||
      storyFromSectionSlugOrder.length < 1
    ) {
      sectionName = uniqueRelatedSections[0].secName;
      setActiveTab("jaksot");
      setSelectedButton(0);
    }
    sectionName = uniqueRelatedSections[0].secName;
    setActiveTab("jaksot");
    setSelectedButton(0);
    setSectionName(sectionName);
    if (oldestToNewest && oldestToNewest === "Vanhin ensin") {
      setIsSort(true); // isSort is used to order storyFromSectionSlugOrder: above code
    }
  }, [collection, childCollections, currentPath]);
  const handleButtonClick = (tab) => {
    setActiveTab(tab);
    setSectionName("");
  };

  useEffect(() => {
    const filterBySectionName = (name) => {
      return storiesFromCollection.filter((item) => item.sections.some((section) => section.name === name));
    };
    const defaultStoriesObjectForJaksot = storiesFromCollection.filter((itemStory) =>
      itemStory.sections.some((sectionItems) => sectionItems.name === uniqueRelatedSections[0].secName)
    );
    const fetchStoriesFromSectionSlug = async () => {
      //if (!uniqueRelatedSections) return;
      //finding kausi section names
      const storiesFromFilterBySecName = sectionName ? filterBySectionName(sectionName) : defaultStoriesObjectForJaksot;
      setStoriesFromSectionSlug(storiesFromFilterBySecName);
    };
    fetchStoriesFromSectionSlug();
  }, [sectionName, collection, childCollections]); //storiesFromSectionSlug dependency check ...
  const [similarSectionParentSlug] = useSimilarSections(oneCollectionData);
  useEffect(() => {
    //finding samanlaisia ohjelmia
    const fetchHomeCollection = async () => {
      if (similarSectionParentSlug && showHideSamanlaisiaOhjelmia === "Päällä") {
        try {
          await fetch(`/api/v1/collections/${similarSectionParentSlug}`)
            .then((res) => res.json())
            .then((json) => {
              const extractedPart = currentPath.replace("/", "");
              const filterExcludeCurrentSimilarSec =
                json.items.filter(
                  (similarCollection) =>
                    similarCollection.type === "collection" && !similarCollection.slug.startsWith(extractedPart)
                ) || [];
              setSimilarSections(filterExcludeCurrentSimilarSec);
            });
        } catch (error) {
          console.error("Error fetching data from external API:", error);
        }
      }
    };
    fetchHomeCollection();
  }, [similarSectionParentSlug]);
  return (
    <React.Fragment>
      <div styleName={`wrapper ${bgColor}`} className="one-big-three-small-section-layout-wrapper">
        <div styleName="">
          <div styleName="container-wrapper">
            <div styleName="big-img">
              <BigSectionHeroImage
                storyObj={firstStory}
                firstEpisode={latestEpisode}
                ageRestriction= {ageRestriction}
                />
              <div styleName="top-button-wrapper">
                <div styleName={`wrapper-active ${activeTab === "jaksot"? "active" : ""}`}>
                <button
                  styleName={
                    selectedButton === "jaksot"
                      ? "selected"
                      : selectedButton !== "tarkemmat" &&
                        selectedButton !== "klipit" &&
                        selectedButton !== "samanlaisia"
                      ? "selected"
                      : ""
                  }
                  onClick={() => {
                    setSelectedButton(0);
                    handleButtonClick("jaksot");
                  }}
                >
                  Jaksot
                </button>
                </div>
                <div styleName={`wrapper-active ${activeTab === "tarkemmat"? "active" : ""}`}>
                <button
                  styleName={selectedButton === "tarkemmat" ? "selected" : ""}
                  onClick={() => {
                    setSelectedButton("tarkemmat");
                    handleButtonClick("tarkemmat");
                  }}
                >
                  Tarkemmat tiedot
                </button>
                </div>
                <div styleName={`wrapper-active ${activeTab === "klipit"? "active" : ""}`}>
                <button
                  styleName={selectedButton === "klipit" ? "selected" : ""}
                  onClick={() => {
                    setSelectedButton("klipit");
                    handleButtonClick("klipit");
                  }}
                >
                  Klipit
                </button>
                </div>
                {similarSectionParentSlug &&
                  showHideSamanlaisiaOhjelmia === "Päällä" &&
                  !currentPath.startsWith("/uusimmat") &&
                  !currentPath.startsWith("/lammas/uusimmat") &&
                  !currentPath.startsWith("/lammas/suosittua-nyt") &&
                  !currentPath.startsWith("/suosittua-nyt") && (
                    <div styleName={`wrapper-active ${activeTab === "samanlaisia"? "active" : ""}`}>
                    <button
                      styleName={selectedButton === "samanlaisia" ? "selected" : ""}
                      onClick={() => {
                        setSelectedButton("samanlaisia");
                        handleButtonClick("samanlaisia");
                        //handleSimilarSectionSlug();
                      }}
                    >
                      Samanlaisia ohjelmia
                    </button>
                    </div>
                  )}
              </div>
              {activeTab === "tarkemmat" && !sectionName && (
                <div styleName="klipit-items">
                  <div styleName="summary">
                    <p>{collection.summary}</p>
                  </div>
                </div>
              )}
              {activeTab === "klipit" && !sectionName && (
                <div styleName="klipit-items">
                  <div styleName="count-sort">
                    <h2>{`${storieKlipit && storieKlipit.length} jaksoa`} </h2>
                  </div>
                  {storieKlipit.map((items) => {
                    return (
                      <React.Fragment>
                        <div styleName="item" className="item" key={items.id}>
                          <ImageType3
                            story={items}
                            behindPaywall={behindPaywall}
                            contentType={contentType}
                            aspectRatio={[[16, 9]]}
                            />
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              )}
              {activeTab === "samanlaisia" && !sectionName && (
                <div styleName="big-img">
                  {similarSections.length >= 1 && (
                    <CollectionOnlyLayout
                      collection={{ items: similarSections, name: "Samanlaisia ohjelmia" }}
                      config={stateConfig}
                    />
                  )}
                </div>
              )}
            </div>

            <div styleName="small-img-wrapper">
              <div styleName="button-wrapper">
                {uniqueRelatedSections.length >= 1 &&
                  activeTab !== "samanlaisia" &&
                  activeTab !== "tarkemmat" &&
                  activeTab !== "klipit" &&
                  !currentPath.startsWith("/uusimmat") &&
                  !currentPath.startsWith("/lammas/uusimmat") &&
                  !currentPath.startsWith("/lammas/suosittua-nyt") &&
                  !currentPath.startsWith("/suosittua-nyt") &&
                  uniqueRelatedSections.map((sectionItems, index) => {
                    //console.log("sectionItems 3", sectionItems);
                    return (
                      <button
                        key={index}
                        styleName={
                          selectedButton === index
                            ? index === 0 && selectedButton === "jaksot"
                              ? "selected"
                              : "selected"
                            : ""
                        }
                        onClick={() => {
                          setSectionName(sectionItems.secName);
                          setActiveTab("");
                          setSelectedButton(index);
                        }}
                      >
                        {sectionItems.secName.split("/")[0]}
                      </button>
                    );
                  })}
                {childCollections &&
                  childCollections.map((names, index) => (
                    <>
                      <button key={index} onClick={() => setCollectionName(names.name)}>
                        {names.name}
                      </button>
                    </>
                  ))}
              </div>
              {activeTab !== "samanlaisia" && activeTab !== "tarkemmat" && activeTab !== "klipit" && (
                <div styleName="count-sort">
                  <h2>{`${storyFromSectionSlugOrder && storyFromSectionSlugOrder.length} jaksoa`} </h2>
                  <i onClick={() => handleSort()} className="ri-arrow-up-down-fill"></i>
                </div>
              )}
              {activeTab !== "samanlaisia" &&
              activeTab !== "tarkemmat" &&
              activeTab !== "klipit" &&
              restOftheStories.length >= 1
                ? (!sectionName ? storyFromSectionSlugOrder : storyFromSectionSlugOrder).map((item, index) => {
                    return (
                      <React.Fragment>
                        <div styleName="item" className="item" key={item.id}>
                          <ImageType3
                            story={item}
                            behindPaywall={behindPaywall}
                            contentType={contentType}
                            aspectRatio={[[16, 9]]}
                            />

                        </div>
                      </React.Fragment>
                    );
                  })
                : activeTab === "jaksot" && (
                    <div styleName="item" className="item">
                      <ImageType3
                        story={firstStory}
                        behindPaywall={behindPaywall}
                        contentType={contentType}
                        aspectRatio={[[16, 9]]}
                        />
                    </div>
                  )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
OneBigThreeSmallSectionLayoutBase.propTypes = {
  collection: object,
  childCollections: array,
  oneCollectionData: object,
  currentPath: string,
};
const OneBigThreeSmallSectionLayout = ({ collection, childCollections, oneCollectionData, behindPaywall, contentType, ageRestriction }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = get(qtState, ["currentPath"], "");
  const storiesFromCollectionV2 = collection.items.map(itemsStories=>itemsStories.story)
  const storiesFromCollection = storiesFromCollectionV2; //collectionToStories(collection);//this method is getting episode image from alternate home s3 bucket which is not desired.

  const reformStoryItems = (storyItems) => {
    const result = {};

    // Group items by series and season
    storyItems.forEach((item) => {
      const [series, season, episode] = item.slug.split("/");
      //log("item 1 series",season);
      if (!result[series]) {
        result[series] = {};
      }

      if (!result[series][season]) {
        result[series][season] = [];
      }

      result[series][season].push({
        episodeSlug: episode,
        "published-at": item["published-at"],
      });
    });

    // Sort episodes within each season by 'published-at' (newest first)
    for (const series in result) {
      for (const season in result[series]) {
        result[series][season].sort((a, b) => a["published-at"] - b["published-at"]);
      }
    }

    // Reformat the result into the desired structure
    const reformedObject = Object.keys(result).map((series) => {
      const seasons = Object.keys(result[series]).map((season) => {
        return {
          [season]: result[series][season],
        };
      });

      return {
        [series]: seasons,
      };
    });

    return reformedObject;
  };

  const reformedObjectContents = reformStoryItems(storiesFromCollection);
  const findEpisodeIndex = (reformedObject, series, season, episodeSlug) => {
    // Find the series object
    const seriesObj = reformedObject.find((item) => item[series]);
    if (!seriesObj) {
      return -1; // Series not found
    }

    // Find the season array
    const seasonObj = seriesObj[series].find((item) => item[season]);
    if (!seasonObj) {
      return -1; // Season not found
    }

    // Find the episode index
    const episodeIndex = seasonObj[season].findIndex((episode) => episode.episodeSlug === episodeSlug);

    return episodeIndex; // Returns -1 if episode not found
  };
const [loadMore,setLoadMore] = useState(50);
const onLoadMoreClick = () => setLoadMore(loadMore+10);
  const defaultImageSlug = get(qtState, ["config", "publisher-attributes", "defaultImageKey"], "");
  return !currentPath.startsWith("/uusimmat") &&
    !currentPath.startsWith("/lammas/uusimmat") &&
    !currentPath.startsWith("/lammas/suosittua-nyt") &&
    !currentPath.startsWith("/suosittua-nyt") ? (
    <OneBigThreeSmallSectionLayoutBase
      collection={collection}
      childCollections={childCollections}
      oneCollectionData={oneCollectionData}
      currentPath={currentPath}
      behindPaywall={behindPaywall}
      contentType={contentType}
      ageRestriction={ageRestriction}
    />
  ) : (
    <div
      styleName={
        currentPath === "/uusimmat" || currentPath.startsWith("/suosittua-nyt") ? "image-grid-wrapper" : "image-grid-wrapper"
      }
    >
      <h2 styleName="collection-name">{collection.name}</h2>
      <div styleName="image-grid">
        {storiesFromCollection.length >= 1 &&
          storiesFromCollection.slice(0,loadMore).map((item) => {
            const [seriesSlug, seasonSlug, episodeSlug] = item.slug.split("/");
            const findEpisodePublishedOrderInSeason = findEpisodeIndex(
              reformedObjectContents,
              seriesSlug,
              seasonSlug,
              episodeSlug
            );
            const publishedSeason = (item.sections?.[0].name).split("/")[0];
            const accessType = item.access;
            const paywallIcons = accessType === "login" || accessType === "subscription";
            return (
              <Link href={`/${item.slug}`} id={item.id} styleName="image-container">
                <ImageType4 story={item} aspectRatio={[[16, 9]]} />
                <div styleName="headline-icon">
                  <h2>{`${item.headline} - ${findEpisodePublishedOrderInSeason + 1}/${publishedSeason}`}</h2>
                  {paywallIcons && (
                    <img alt="audio-logo" src="/icons/under-subcription.svg" styleName="custom-img-icon" />
                  )}
                </div>
              </Link>
            );
          })}
          <div styleName="title-loadmore">
            <button styleName="btn-2" onClick={onLoadMoreClick}>Loadmore</button>
          </div>
      </div>
    </div>
  );
};
OneBigThreeSmallSectionLayout.propTypes = {
  collection: object,
  childCollections: array,
  oneCollectionData: object,
};
export { OneBigThreeSmallSectionLayout };

OneBigThreeSmallSectionLayout.storyLimit = 100;
